<script lang="ts">
  import { defineFilter } from './stakeholder-search-operators'
  import { createContext } from 'reka-ui'

  export interface SearchFilterContext<
    T extends Record<string, ReturnType<typeof defineFilter>>
  > {
    searchFilters: T
  }

  // The injection key holds the consumer's filter shape generically;
  // tightening it to `unknown` breaks every `useSearchFilter<T>()` call.
  const [_useSearchFilter, provideSearchFilter] = createContext<
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    SearchFilterContext<any>
  >('gs-search-filter-context')

  export function useSearchFilter<
    T extends Record<string, ReturnType<typeof defineFilter>>
  >() {
    return _useSearchFilter() as SearchFilterContext<T>
  }
</script>

<script
  setup
  lang="ts"
  generic="T extends Record<string, ReturnType<typeof defineFilter>>"
>
  const props = defineProps<{
    searchFilters: T
  }>()

  provideSearchFilter({
    searchFilters: props.searchFilters
  })
</script>
<template>
  <slot />
</template>
